import useQueryRemoteTemplates from "../../queries/remote/useQueryRemoteTemplates";

export default function useRemoteTemplates() {
  const remoteTemplatesQuery = useQueryRemoteTemplates();

  let templates = null;
  if (remoteTemplatesQuery?.data?.templates) {
    templates = remoteTemplatesQuery.data.templates;
  }

  return { remoteTemplatesQuery, templates };
}
